export const mainDescription = [
    {
        key: 'deti',
        text: 'Присматривайте за ребенком, находясь вдалеке от дома. Будьте уверены, что дома все спокойно. Установите ip-камеры домашнего видеонаблюдения с абонентской платой всего за 1 руб. мес.*'
    },
    {
        key: 'roditeli',
        text: 'Камера Дом.ru обеспечит дистанционный уход за престарелыми родителями. Вы сможете мгновенно среагировать в случае возникновения экстренной ситуации. Установите ip-камеры домашнего видеонаблюдения с абонентской платой всего за 1 руб. мес.*'
    },
    {
        key: 'remont',
        text: 'К вам приходит домработница, или за вашим ребенком присматривает няня? У вас дома идет ремонт? Будьте уверены, что дома все под контролем. Установите ip-камеры домашнего видеонаблюдения с абонентской платой всего за 1 руб. мес.*'
    },
    {
        key: 'pitomtsi',
        text: 'Скучаете по своему домашнему питомцу? Установите ip-камеры домашнего видеонаблюдения с абонентской платой всего за 1 руб. мес.*'
    },
    {
        key: 'apartments',
        text: 'Обеспечьте безопасность своей семьи и вашего  жилья прямо сейчас, установив ip камеры домашнего видеонаблюдения с абонентской платой всего за 1 руб. мес.*'
    },
    {
        key: 'avto',
        text: 'Часто уезжаете в командировки или отпуск, а машину паркуете во дворе? Хотите заранее знать есть ли места для машины? Установите ip-камеры внешнего видеонаблюдения с абонентской платой всего 250 руб./мес'
    },
];
